import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/index.css';
import App from '@/App';
import { injectColorsToCSS } from '@/utils/colorInjector';

// Inject powerColors as CSS variables
injectColorsToCSS();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
